import styled from 'styled-components';

import { FilterChip } from '@/ui/Chip';

const ContainerStyled = styled.div`
  display: flex;
  justify-content: space-between;
`;

const TextBlockStyled = styled.div`
  display: flex;
  flex-direction: column;
`;

const TitleStyled = styled.p`
  ${(p) => p.theme.typography.body3};
  color: ${(p) => p.theme.tones.neutral[10]};
`;

const SubtitleStyled = styled.p`
  ${(p) => p.theme.typography.caption};
  color: ${(p) => p.theme.colors.neutral.outline2};
`;

type JourneyAddTeamsModalTeamItemProps = {
  id: number;
  name: string;
  total: number;
  isAdded: boolean;
  onAddTeam: (id: number, isAdded: boolean) => void;
};

export const JourneyAddTeamsModalTeamItem = ({
  name,
  total,
  isAdded,
  id,
  onAddTeam,
}: JourneyAddTeamsModalTeamItemProps): React.ReactElement => {
  return (
    <ContainerStyled>
      <TextBlockStyled>
        <TitleStyled>{name}</TitleStyled>
        <SubtitleStyled>{`${total} members`}</SubtitleStyled>
      </TextBlockStyled>
      <FilterChip label={isAdded ? 'Added' : 'Add'} variant="outline" selected={isAdded} onClick={() => onAddTeam(id, isAdded)} />
    </ContainerStyled>
  );
};
